import { render, staticRenderFns } from "./followedStoreItem.vue?vue&type=template&id=08a1d28a&scoped=true"
import script from "./followedStoreItem.vue?vue&type=script&lang=js"
export * from "./followedStoreItem.vue?vue&type=script&lang=js"
import style0 from "./followedStoreItem.vue?vue&type=style&index=0&id=08a1d28a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1d28a",
  null
  
)

export default component.exports